import Popup from 'reactjs-popup';
import React, { Component } from "react"; 
import 'reactjs-popup/dist/index.css';
import LoadingIndicator from '../components/LoadingIndicator';
import PDFPreviewLink from '../components/PDFPreviewLink';
import Selector from '../components/Selector';
import FilterSelector from '../components/FilterSelector';
import {getBrokers, getCompanyList, createTower, getTower} from '../services/BinderDropService';
import {ShrinkNumber} from '../util/Helper'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class TowerDetailsPopup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tower:{},
      companies:[],
      brokers:[],
    };
  }

  onOpen = () => {
      getBrokers().then((brokers) => {
        this.setState({brokers});
      });

      getCompanyList().then((companies) => {
        this.setState({companies});
      });


      if(this.props.tower.effectiveDate) this.props.tower.effectiveDate = new Date(this.props.tower.effectiveDate);
      if(this.props.tower.expirationDate) this.props.tower.expirationDate = new Date(this.props.tower.expirationDate);

      this.setState({tower:this.props.tower, saving:false});
  }

  componentDidUpdate(prevProps) {
    if(prevProps && prevProps.loading !== this.props.loading){
      if(this.props.tower.effectiveDate) this.props.tower.effectiveDate = new Date(this.props.tower.effectiveDate);
      if(this.props.tower.expirationDate) this.props.tower.expirationDate = new Date(this.props.tower.expirationDate);

      this.setState({tower:this.props.tower, saving:false});
    } 
  }

  handleDateSelect = (e) => {
    console.log(e);
  }


  onCloseClick = () =>{
    this.props.onClose(false);
  }

  onSaveClick = () => {
   
    if(this.state.tower.broker?.brokerId && this.state.tower.expirationDate && this.state.tower.effectiveDate && this.state.tower.company?.companyId){
      this.setState({saving:true});
      createTower(this.state.tower).then((resp) => {
        if(resp?.towerId){
          getTower(resp?.towerId).then((tower) => {
            this.props.onClose(tower);
          });
        }
        else{//TODO show error
          this.setState({saving:false});
        }
      });   
    }
    else{
      //TODO show error
    }
  };


  render() {

    return (
        <Popup className='towerDetailsPopup popupInputFields' onOpen={this.onOpen} closeOnDocumentClick={false} open={this.props.open} position="center center">
                    
                    <label>Verify Tower Details</label>
                    <div className='popupSplit'>
                      <div className='popupSplitHalf card'>
                        {this.props.pdf && this.props.pdf.base64String &&
                          <PDFPreviewLink pdf={this.props.pdf}/>
                        }
                       
                      </div>
                      <div className='popupSplitHalf'>
                      {this.props.loading &&
                            <LoadingIndicator text="Processing PDF(s)..."/>
                        }
                        {!this.props.loading &&
                        <div className="popupContentInner">
                            <span>Insured Account</span>
                            <FilterSelector  searchPlaceholderText="Type to find company" placeholderText="Select company" defaultValue={this.state.tower.company}  options={this.state.companies} onChange={(e) => this.setState({ tower: { ...this.state.tower, company: e} })}/>
                          
                            <span>Broker</span>
                            <FilterSelector  searchPlaceholderText="Type to find broker" placeholderText="Select broker" defaultValue={this.state.tower.broker} options={this.state.brokers} onChange={(e) => this.setState({ tower: { ...this.state.tower, broker: e} })}/>
                            <input style={{display:'none'}}/>
                            
                            <span>Effective Date</span>
                            <DatePicker placeholderText="Click to select a date" showYearDropdown dateFormat="MM/dd/yyyy" className="fieldInput" selected={this.state.tower.effectiveDate} endDate={this.state.tower.expirationDate} onChange={(date) => this.setState({ tower: { ...this.state.tower, effectiveDate: date} })} />
                            <span>Expiration Date</span>
                            <DatePicker placeholderText="Click to select a date"  showYearDropdown dateFormat="MM/dd/yyyy" minDate={this.state.tower.effectiveDate} className="fieldInput" selected={this.state.tower.expirationDate} endDate={this.state.tower.expirationDate} onChange={(date) => this.setState({ tower: { ...this.state.tower, expirationDate: date} })} />
                            
                            <button tabIndex={1} className='pillButton'  onClick={this.onSaveClick}>Create Tower</button>
                            <a  onClick={this.onCloseClick}>Or Cancel</a>
                        </div>
                        }
                        {this.state.saving &&
                        <div className="popupOverlay">
                          <span>Creating Tower...</span>
                        </div>
                        }
                      </div>
                    </div>
        </Popup>
    );
  }
}
 
export default TowerDetailsPopup;